export const getMadeToOrderText = function (isMadeToOrder) {
    return isMadeToOrder ? 'Made to Order' : null
}

export const getFreeShippingText = function (shippingData) {
    // Make sure we have an isEligibleFreeShipping prop
    if (!shippingData?.isEligibleFreeShipping) return

    const shippingText =
        'Free' +
        // if free then add with space before and after, otherwise just a space
        (shippingData.isFreight ? ' Freight ' : ' ') +
        'Shipping'

    return shippingText
}

export const getTimeRemainingText = function (shippingData) {
    // Make sure we have a sameDay obj
    if (!shippingData?.sameDay) return {}

    const { startDayOfWeek, endDayOfWeek, cutoffTime } = shippingData.sameDay

    const today = new Date()
    const todayMS = today.getTime()

    // Api properly returns the date now along with the time
    // so we don't need to create another local date just to make sure we have the correct day
    const cutoff = new Date(cutoffTime)

    const cutoffMS = cutoff.getTime()
    const startDay = getNumericDay(startDayOfWeek)
    const endDay = getNumericDay(endDayOfWeek)
    const beforeCutoffTime = todayMS < cutoffMS
    const betweenStartAndEndDays = today.getDay() >= startDay && today.getDay() <= endDay

    if (beforeCutoffTime && betweenStartAndEndDays) {
        // show countdown
        const countdown = cutoffMS - todayMS
        const hours = Math.floor(countdown / 1000 / 60 / 60)
        const minutes = Math.floor(countdown / 1000 / 60) % 60
        const seconds = Math.floor(countdown / 1000) % 60

        let hoursString = ''
        if (hours === 0) hoursString = ''
        else if (hours > 9) hoursString = `${hours}h`
        else hoursString = `0${hours}h`

        const orderText =
            'Ships' +
            // if free then add with space before and after, otherwise just a space
            (shippingData.isEligibleFreeShipping ? ' FREE ' : ' ') +
            'today if ordered within '

        return {
            orderText,
            hours: hoursString,
            minutes: minutes > 9 ? `${minutes}m` : `0${minutes}m`,
            seconds: seconds > 9 ? `${seconds}s` : `0${seconds}s`,
        }
    }

    if (
        // if during week and a day or more before end day
        (betweenStartAndEndDays && today.getDay() <= endDay - 1) ||
        // or not during week and day before start day
        (!betweenStartAndEndDays && today.getDay() === startDay - 1)
    ) {
        const orderText =
            'Order today, ships' +
            // if free then add with space before and after, otherwise just a space
            (shippingData.isEligibleFreeShipping ? ' FREE ' : ' ') +
            'tomorrow'
        return {
            orderText,
        }
    }

    return {}
}

export const sameDayShippingDisplayMixin = {
    computed: {
        sameDayShippingBackgroundColor() {
            return this.$sitewideData.config.sameDayShippingMode === 'RAPIDSHIP'
                ? 'bg-success'
                : 'bg-info'
        },
        sameDayShippingBorderColor() {
            return this.$sitewideData.config.sameDayShippingMode === 'RAPIDSHIP'
                ? 'border-success'
                : 'border-info'
        },
        sameDayShippingTextColor() {
            return this.$sitewideData.config.sameDayShippingMode === 'RAPIDSHIP'
                ? 'text-success'
                : 'text-info'
        },
        sameDayShippingText() {
            return this.$sitewideData.config.sameDayShippingMode === 'RAPIDSHIP'
                ? 'RapidShip'
                : 'QuickShip'
        },
    },
}

/**
 *
 * @param {object} shippingData
 * @param {boolean} includeDate - Used by Segment but front end needs text and date separated
 * @returns
 */
export const getEddText = function (shippingData, includeDate = false) {
    if (!shippingData.estimatedDeliveryDate) return

    let text = 'Arrives'
    if (includeDate) text = `${text} ${getEddDate(shippingData)}`
    return text
}

export const getEddDate = function (shippingData) {
    if (!shippingData.estimatedDeliveryDate) return

    const { min, max } = shippingData.estimatedDeliveryDate
    // const min = '2021-01-02T13:00:00.000Z'
    // const max = '2021-01-02T13:00:00.000Z'

    if (min === max) {
        const d = getDateObject(min)
        return `${d.day}, ${d.monthStr} ${d.date}${d.dateSuffix}`
    } else {
        const minD = getDateObject(min)
        const maxD = getDateObject(max)
        const maxMonthString = minD.month !== maxD.month ? maxD.monthStr + ' ' : ''
        return `${minD.monthStr} ${minD.date}${minD.dateSuffix} - ${maxMonthString}${maxD.date}${maxD.dateSuffix}`
    }
}

export const getOrdinal = function (day) {
    if (day > 3 && day < 21) return 'th'
    if (day % 10 === 1) return 'st'
    if (day % 10 === 2) return 'nd'
    if (day % 10 === 3) return 'rd'
    return 'th'
}

function getNumericDay(day) {
    return ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'].indexOf(day)
}

function getDateObject(date) {
    const d = new Date(date)
    return {
        month: d.getUTCMonth(),
        monthStr: getFullNameMonth(d.getUTCMonth()),
        day: getFullNameDay(d.getUTCDay()),
        date: d.getUTCDate(),
        dateSuffix: getOrdinal(d.getUTCDate()),
    }
}

function getFullNameDay(day) {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    return days[day] || ''
}

function getFullNameMonth(month) {
    const months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
    ]
    return months[month] || ''
}
